module.exports = __webpack_public_path__ + "img/black-1.82f2a211.png";